/**
 * @author 3173
 * @description 新增/编辑
 * @Date  2020/9/28
 */
import React from "react";
import { connect } from "dva";
import { component_tool, framework_tool, utils_tool } from '@/tool';
import HomeworkForm from './homeworkForm'
import moment from "moment";
// import { wizNotice } from "wiz-components/lib";
import { formatAuth } from '@/utils/commonUtils'
let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizForm, WizSpin } = component_tool;
let { Session } = utils_tool


class HomeworkDetail extends WizContainer {
  componentName = 'homeworkDetail';

  constructor(props) {
    super(props);
    const { history } = this.props;
    let initialValue = {};
    let positionState = 1;
    let cardTitle = '新增';
    if (history.location && history.location.pathname === '/homework/homeworkList/homeworkUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        positionState = initialValue.state;
        Session.set('homeworkUpd', initialValue)
      } else {
        initialValue = Session.get('homeworkUpd') || {};
      }
      cardTitle = '编辑'
      if (initialValue.startDate) { 
        initialValue.startDate = moment(initialValue.startDate, 'YYYY-MM-DD HH:mm:ss')
      }
      if (initialValue.endDate) { 
        initialValue.endDate = moment(initialValue.endDate, 'YYYY-MM-DD HH:mm:ss')
      }
      if (initialValue.submitStartDate) { 
        initialValue.submitStartDate = moment(initialValue.submitStartDate, 'YYYY-MM-DD HH:mm:ss')
      }
      if (initialValue.submitEndDate) { 
        initialValue.submitEndDate = moment(initialValue.submitEndDate, 'YYYY-MM-DD HH:mm:ss')
      }
    }
    this.state = {
      cardTitle: cardTitle,
      formKey: 'homeworkForm',
      formInitialValue:{}
    }
    this.initialValue = initialValue;
  }

  _componentDidMount() {
    if (this.initialValue.id) {
      this.doAction({
        path: 'homework/getInfo',
        payload: {
          key: "getHomeworkInfo",
          apiParams: {
            id: this.initialValue.id
          }
        }
      });
    }
  }


  propsAndStateOnChange = {
    saveHomework: this._saveHomeworkOver.bind(this),
    homeworkInfo: this._getHomeworkInfoOver.bind(this)
  }


  _saveHomeworkOver(nextProps, nextState) {
    if (nextProps.saveHomework.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/homework/homeworkList');
    } else {
      wizNotice.error('提交失败：' + nextProps.saveHomework.msg);
    }
    return true;
  }

  _getHomeworkInfoOver(nextProps, nextState) {
    if (nextProps.homeworkInfo.code == 1) {
      this.initialValue = nextProps.homeworkInfo.data; 
      if(this.initialValue.categoryId && this.initialValue.categoryName){
        this.initialValue.categoryInfo = [{key:this.initialValue.categoryId,title:this.initialValue.categoryName}]
      }
      if (this.initialValue.startDate) { 
        this.initialValue.startDate = moment(this.initialValue.startDate, 'YYYY-MM-DD HH:mm:ss')
      }
      if (this.initialValue.endDate) { 
        this.initialValue.endDate = moment(this.initialValue.endDate, 'YYYY-MM-DD HH:mm:ss')
      }
      if (this.initialValue.submitStartDate) { 
        this.initialValue.submitStartDate = moment(this.initialValue.submitStartDate, 'YYYY-MM-DD HH:mm:ss')
      }
      if (this.initialValue.submitEndDate) { 
        this.initialValue.submitEndDate = moment(this.initialValue.submitEndDate, 'YYYY-MM-DD HH:mm:ss')
      }
      nextState.formInitialValue = Object.assign({},this.initialValue)
      nextState.formKey = 'homeworkForm' + new Date().getTime()
    } 
    return true;
  }


  /**
   * 保存/更新
   * @param values
   * @private
   */
  _save(values) {
    const { history } = this.props;
    let apiPath = "homework/add";
    if (this.initialValue.id) {
      apiPath = "homework/update";
    }
    if (values && values['imgList'] && values['imgList'].length) {
      if(values['imgList'].length>19){
        wizNotice.warn("图片数量不可超过19张,请确认后重试");
        return null;
      }
      let imgListNew = []
      values['imgList'].forEach(element => {
        imgListNew.push(element.fileId)
      });
      values['imgList'] = imgListNew;
    } else {
      values.imgList = [];
    }


    if (values && values['videoList'] && values['videoList'].length) {
      if(values['videoList'].length>9){
        wizNotice.warn("视频数量不可超过9个,请确认后重试");
        return null;
      }
      let newVideoList = []
      values['videoList'].forEach(element => {
        newVideoList.push(element.fileId)
      });
      values['videoList'] = newVideoList;
    } else {
      values.videoList = [];
    }


    if (values && values['audioList'] && values['audioList'].length) {
      if(values['audioList'].length>9){
        wizNotice.warn("音频数量不可超过9个,请确认后重试");
        return null;
      }
      let newAudioList = []
      values['audioList'].forEach(element => {
        newAudioList.push(element.fileId)
      });
      values['audioList'] = newAudioList;
    } else {
      values.audioList = [];
    }


    if (values && values['fileList'] && values['fileList'].length) {
      if(values['fileList'].length>9){
        wizNotice.warn("文件数量不可超过9个,请确认后重试");
        return null;
      }
      let fileListNew = []
      values['fileList'].forEach(element => {
        fileListNew.push(element.fileId)
      });
      values['fileList'] = fileListNew;
    } else {
      values.fileList = [];
    }



    if (values['startDate'] && values['startDate']._d.getTime()) {
      values.startDate = new Date (values['startDate']).getTime();
    }
    if (values['endDate'] && values['endDate']._d.getTime()) {
      values.endDate =new Date (values['endDate']).getTime();
    }

    if(values.startDate >  values.endDate){
      wizNotice.warn("结束时间不可早于开始时间,请确认后重试");
      return null;
    }

    if (values['submitStartDate'] && values['submitStartDate']._d.getTime()) {
      values.submitStartDate = new Date (values['submitStartDate']).getTime();
    }
    if (values['submitEndDate'] && values['submitEndDate']._d.getTime()) {
      values.submitEndDate =new Date (values['submitEndDate']).getTime();
    }

    if(values.submitStartDate >  values.submitEndDate){
      wizNotice.warn("允许提交结束时间不可早于允许提交开始时间,请确认后重试");
      return null;
    }
    
    //console.log("values==",values)
    // if(values.submitStartDate <  values.startDate){
    //   wizNotice.warn("允许提交开始时间不可早于开始时间,请确认后重试");
    //   return null;
    // }

    // if(values.submitEndDate >  values.endDate){
    //   wizNotice.warn("允许提交结束时间不可晚于结束时间,请确认后重试");
    //   return null;
    // }

    if( values.reviewerList &&  values.reviewerList.length>30 ){
      wizNotice.warn("评分人不可大于30人,请确认后重试");
      return null;
    }
    if( values.passScore===0 ||  values.totalScore===0 ){
      wizNotice.warn("及格分或满分不可为0");
      return null;
    }
    if( !values.passScore &&  values.totalScore ){
      wizNotice.warn("请输入及格分或清空满分");
      return null;
    }
    if( values.passScore && values.totalScore && values.totalScore < values.passScore ){
      wizNotice.warn("及格分不可高于满分,请确认后重试");
      return null;
    }

    if(values.categoryId){
      values.categoryId = values.categoryId[0];
    }

    // let authCmd = {}
    // if (values['authCmd']) {
    //   let authInfo = values['authCmd']
    //   authCmd.isAll = authInfo.isAll
    //   authCmd['orgIds'] = authInfo['orgIds'] && authInfo['orgIds'].map(p => (p.id))
    //   authCmd['positionIds'] = authInfo['positionIds'] && authInfo['positionIds'].map(p => (p.id))
    //   authCmd['positionCategoryIds'] = authInfo['positionCategoryIds'] && authInfo['positionCategoryIds'].map(p => (p.id))
    //   authCmd['personIds'] = authInfo['personIds'] && authInfo['personIds'].map(p => (p['id']))
    // }
    // values['authCmd'] = authCmd;

    values.authCmd = formatAuth(values.authCmd)

    if(!values.state && values.state!=0){
      values.state = this.props.homeworkInfo.data.state;
    }
    this.doAction({
      path: apiPath,
      payload: {
        key: "saveHomework",
        apiParams: {
          ...values,
          id: this.initialValue.id
        }
      }
    });
  }


  _render() {
    const { homeworkLoading } = this.props;
    let { cardTitle, formInitialValue } = this.state;

   

    return <WizCard>
      <WizSpin tip={'加载中'} spinning={homeworkLoading}>
      
        <HomeworkForm className={'form-inline'} key={this.state.formKey} initialValue={this.initialValue}
          onSubmit={this._save.bind(this)} />
       
      </WizSpin>
    </WizCard>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { homework } = state;
  const saveHomework = modelUtils.getModelEntity(homework, "saveHomework");
  const homeworkInfo = modelUtils.getModelEntity(homework, "getHomeworkInfo");
  const load = modelUtils.getLoadingState(state, ['homework']);
  return {
    saveHomework: saveHomework,
    homeworkInfo,
    ...load
  }
};

export default connect(mapStateToProps)(HomeworkDetail);
